export const darkTheme = {
  fds: {
    primary: "#ffffff",
    secondary: "#90949a",
    tertiary: "#6a6e75",
    placeholder: "#6a6e75",
    disable: "#52565c",
    "on-inverse": "#202123",
    brand: {
      DEFAULT: "#3064c0",
      hover: "#5983cd",
      select: "#7497d5",
      dark: "#1A376A",
    },
    "on-brand": {
      DEFAULT: "#ffffff",
      light: {
        DEFAULT: "#3064c0",
        hover: "#5983cd",
        select: "#7497d5",
      },
    },
    accent: {
      DEFAULT: "#057c82",
      hover: "#37969b",
      select: "#58a7ab",
    },
    "on-accent": {
      DEFAULT: "#ffffff",
      light: {
        DEFAULT: "#057c82",
        hover: "#37969b",
        select: "#58a7ab",
      },
    },
    danger: {
      DEFAULT: "#d22d3d",
      hover: "#db5764",
      select: "#e1727d",
    },
    "on-danger": {
      DEFAULT: "#ffffff",
      light: {
        DEFAULT: "#ffffff",
        hover: "#e1727d",
        select: "#ea9ea6",
      },
    },
    success: {
      DEFAULT: "#278062",
      hover: "#529981",
      select: "#6eaa96",
    },
    "on-success": {
      DEFAULT: "#ffffff",
      light: {
        DEFAULT: "#278062",
        hover: "#529981",
        select: "#6eaa96",
      },
    },
    warning: {
      DEFAULT: "#ffb52b",
      hover: "#ffc455",
      select: "#ffcd71",
    },
    "on-warning": {
      DEFAULT: "#202123",
      light: {
        DEFAULT: "#e8a527",
        hover: "#e8a527",
        select: "#ffc455",
      },
    },
    info: {
      DEFAULT: "#0c68f4",
      hover: "#3d86f6",
      select: "#5c9af8",
    },
    "on-info": {
      DEFAULT: "#ffffff",
      light: {
        DEFAULT: "#0c68f4",
        hover: "#3d86f6",
        select: "#5c9af8",
      },
    },
    always: {
      dark: "#202123",
      grey: "#6e798d",
      white: "#ffffff",
    },
    link: {
      default: "#3064c0",
      hover: "#5983cd",
      disable: "#52565c",
    },
    canvas: {
      primary: "#2A2B2D",
      secondary: "#5983cd",
    },
  },
};

export const lightTheme = {
  fds: {
    primary: "#202123",
    secondary: "#52565c",
    tertiary: "#747981",
    placeholder: "#6e798d",
    disable: "#a2a5ab",
    inverse: "#313336",
    "on-inverse": "#ffffff",
    warningAccess: "#e4ab02",
    brand: {
      DEFAULT: "#3064c0",
      hover: "#2c5baf",
      select: "#224788",
      dark: "#1A376A",
    },
    on: {
      brand: {
        DEFAULT: "#ffffff",
        light: {
          DEFAULT: "#3064c0",
          hover: "#2c5baf",
          select: "#224788",
        },
      },
    },
    accent: {
      DEFAULT: "#057c82",
      hover: "#057176",
      select: "#04585c",
    },
    "on-accent": {
      DEFAULT: "#ffffff",
      light: {
        DEFAULT: "#057c82",
        hover: "#057176",
        select: "#04585c",
      },
    },
    danger: {
      DEFAULT: "#d22d3d",
      hover: "#bf2938",
      select: "#95202b",
    },
    "on-danger": {
      DEFAULT: "#ffffff",
      light: {
        DEFAULT: "#bf2938",
        hover: "#95202b",
        select: "#741922",
      },
    },
    success: {
      DEFAULT: "#278062",
      hover: "#237459",
      select: "#1c5b46",
    },
    "on-success": {
      DEFAULT: "#ffffff",
      light: {
        DEFAULT: "#278062",
        hover: "#237459",
        select: "#1c5b46",
      },
    },
    warning: {
      DEFAULT: "#ffb52b",
      hover: "#e8a527",
      select: "#b5811f",
    },
    "on-warning": {
      DEFAULT: "#202123",
      light: {
        DEFAULT: "#6b4c12",
        hover: "#202123",
        select: "#2C1F07",
      },
    },
    info: {
      DEFAULT: "#0c68f4",
      hover: "#0b5fde",
      select: "#094aad",
    },
    "on-info": {
      DEFAULT: "#ffffff",
      light: {
        DEFAULT: "#0c68f4",
        hover: "#0b5fde",
        select: "#094aad",
      },
    },
    always: {
      dark: "#202123",
      grey: "#6e798d",
      white: "#ffffff",
    },
    link: {
      DEFAULT: "#3064c0",
      hover: "#2c5baf",
      disable: "#a2a5ab",
    },
    canvas: {
      primary: "#FAFAFA",
      secondary: "#F9FBFD",
    },
  },
};
